import { oneSessionPerNight, sleepMinutes } from './from-device.js';
/** Waking for up to this long is still the same sleep. */
const SAME_SLEEP_GAP_MS = 60 * 60_000;
export function sleepNightsByApp(sessions, localDate) {
    const byApp = new Map();
    for (const s of sessions) {
        const app = s.sourceId ?? null;
        byApp.set(app, [...(byApp.get(app) ?? []), s]);
    }
    const out = [];
    for (const [app, own] of byApp) {
        const sorted = oneSessionPerNight(own).sort((a, b) => Date.parse(a.startDate) - Date.parse(b.startDate));
        const stretches = [];
        for (const s of sorted) {
            const minutes = sleepMinutes(s);
            if (minutes.total <= 0)
                continue;
            const start = Date.parse(s.startDate);
            const end = Date.parse(s.endDate);
            const hasStages = (s.stages?.length ?? 0) > 0;
            const last = stretches[stretches.length - 1];
            if (last && start - last.end <= SAME_SLEEP_GAP_MS) {
                last.total += minutes.total;
                last.deep += minutes.deep;
                last.light += minutes.light;
                last.rem += minutes.rem;
                last.hasStages ||= hasStages;
                if (end > last.end) {
                    last.end = end;
                    last.endIso = s.endDate;
                }
            }
            else {
                stretches.push({ end, endIso: s.endDate, total: minutes.total, deep: minutes.deep, light: minutes.light, rem: minutes.rem, hasStages });
            }
        }
        const byDate = new Map();
        for (const st of stretches) {
            const date = localDate(st.endIso);
            byDate.set(date, [...(byDate.get(date) ?? []), st]);
        }
        for (const [date, list] of byDate) {
            const main = list.reduce((a, b) => (b.total > a.total ? b : a));
            out.push({
                date,
                app,
                sleepMin: Math.min(1440, main.total),
                napMin: list.filter((st) => st !== main).reduce((t, st) => t + st.total, 0),
                deepMin: main.hasStages ? main.deep : null,
                lightMin: main.hasStages ? main.light : null,
                remMin: main.hasStages ? main.rem : null,
                hasStages: main.hasStages,
            });
        }
    }
    return out.sort((a, b) => a.date.localeCompare(b.date) || String(a.app).localeCompare(String(b.app)));
}
/**
 * The family a sleep source belongs to, so a preference for Withings covers
 * the mat whether it arrives directly or through the phone's health store.
 */
export function sleepSourceFamily(source) {
    const s = source.toLowerCase();
    if (s === 'manual')
        return 'manual';
    if (s.includes('withings'))
        return 'withings';
    if (/com\.mi\.health|xiaomi|mifit/.test(s))
        return 'mi_fitness';
    if (s.includes('garmin'))
        return 'garmin';
    if (s.includes('fitbit'))
        return 'fitbit';
    if (s.includes('oura'))
        return 'oura';
    if (s.includes('shealth') || s.includes('samsung'))
        return 'samsung_health';
    if (s.includes('com.google.android.apps.fitness'))
        return 'google_fit';
    const app = s.split(':')[1];
    return app && app !== 'unknown' ? app : 'phone';
}
//# sourceMappingURL=sleep-nights.js.map